import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedReportsPanel = ({ reports = [], onLoadReport, onDeleteReport }) => {
  const defaultReports = [
    {
      id: 1,
      name: 'تقرير الأداء الشهري',
      description: 'ملخص شامل للأداء خلال الشهر الحالي',
      icon: 'FileText',
      lastModified: '٢٠٢٦/٠١/٠٨',
      category: 'monthly'
    },
    {
      id: 2,
      name: 'تحليل العملاء الجدد',
      description: 'إحصائيات اكتساب العملاء الجدد',
      icon: 'Users',
      lastModified: '٢٠٢٦/٠١/٠٥',
      category: 'clients'
    },
    {
      id: 3,
      name: 'أداء الموظفين',
      description: 'مقارنة إنتاجية الموظفين',
      icon: 'Award',
      lastModified: '٢٠٢٦/٠١/٠٣',
      category: 'staff'
    },
    {
      id: 4,
      name: 'تقرير الإيرادات',
      description: 'تحليل الإيرادات حسب نوع العقار',
      icon: 'DollarSign',
      lastModified: '٢٠٢٦/٠١/٠١',
      category: 'revenue'
    },
    {
      id: 5,
      name: 'معدلات التحويل',
      description: 'تحليل معدلات تحويل العملاء المحتملين',
      icon: 'TrendingUp',
      lastModified: '٢٠٢٥/١٢/٢٨',
      category: 'conversion'
    }
  ];

  const reportsList = reports?.length > 0 ? reports : defaultReports;

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="BookmarkCheck" size={20} />
          التقارير المحفوظة
        </h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="Plus"
          iconPosition="right"
        >
          جديد
        </Button>
      </div>
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {reportsList?.map((report) => (
          <div
            key={report?.id}
            className="p-3 rounded-lg border border-border hover:bg-muted transition-all duration-250 cursor-pointer group"
            onClick={() => onLoadReport && onLoadReport(report)}
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={report?.icon} size={18} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground mb-1 truncate">
                  {report?.name}
                </h4>
                <p className="text-xs text-muted-foreground line-clamp-2 mb-2">
                  {report?.description}
                </p>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Icon name="Calendar" size={12} />
                  <span>{report?.lastModified}</span>
                </div>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={(e) => {
                  e?.stopPropagation();
                  onDeleteReport && onDeleteReport(report?.id);
                }}
                iconName="Trash2"
                iconSize={16}
                className="opacity-0 group-hover:opacity-100 transition-opacity"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedReportsPanel;